export default "__VITE_ASSET__8KVVcu33__"